import Image from 'next/image'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'

import type { FC, HTMLProps, ReactElement } from 'react'

interface CenterDialogProps extends HTMLProps<HTMLDialogElement> {
  isLoading: boolean
  handleClose?: Function
  handleCTA: Function
  handleCTASecondary?: Function
  description: string
  title?: string
  CTAText?: string
  IconImage?: ReactElement
  CTATextSecondary?: string
  dismissable?: boolean
}

const CenterDialog: FC<CenterDialogProps> = ({
  handleClose = () => {},
  isLoading,
  handleCTA,
  handleCTASecondary,
  open,
  description,
  title = 'Simpan draf sebelum keluar?',
  CTAText = 'Simpan dan keluar',
  CTATextSecondary,
  IconImage = (
    <Image
      src="/illustrations/img-save-document-drive.png"
      alt=""
      width="120"
      height="120"
    />
  ),
  dismissable = true,
}) => {
  return (
    <Dialog
      isOpen={open}
      onClose={isLoading ? null : () => handleClose()}
      closeOnOverlayClick={dismissable}
    >
      <DialogOverlay />
      <DialogContent className="p-4 max-w-2xl m-auto self-center">
        <div className="flex justify-center">{IconImage}</div>
        <Text variant="heading-sm" className="mt-4 mb-1">
          {title}
        </Text>

        <Text variant="body">{description}</Text>

        <Button
          className="mt-4 mb-2"
          color="blue"
          disabled={isLoading}
          isLoading={isLoading}
          onClick={() => handleCTA()}
          size="lg"
          fullWidth
        >
          {CTAText}
        </Button>
        {CTATextSecondary && (
          <Button
            color="white"
            size="lg"
            fullWidth
            disabled={isLoading}
            onClick={() => handleCTASecondary()}
          >
            {CTATextSecondary}
          </Button>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default CenterDialog
